module.exports = __webpack_public_path__ + "static/banner-part-6-dfff8af19819deb6f09db201d3add443.svg";